import React from "react"
import {
  FormControlLabel,
  FormLabel,
  Checkbox,
  CheckboxProps,
  Typography,
  styled,
} from "@mui/material"

import { colors } from "theme"

type Props = CheckboxProps & {
  label: React.ReactNode | string
  value: boolean
  helperText?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const Label = styled(FormLabel)(() => ({
  color: colors.indigo,
  fontSize: "0.875rem",
  fontWeight: "400",
  lineHeight: "1.4",
}))

const CheckboxComponent = styled(
  ({ label, value, helperText, onChange, ...restProps }: Props) => (
    <>
      <FormControlLabel
        disableTypography
        control={
          <Checkbox
            {...restProps}
            color="primary"
            checked={value}
            value={value}
            onChange={onChange}
          />
        }
        label={
          <Label>
            {label}
            {helperText && (
              <Typography
                component="div"
                variant="caption"
                sx={{ color: colors.ruby }}
              >
                {helperText}
              </Typography>
            )}
          </Label>
        }
      />
    </>
  ),
)(() => ({
  alignSelf: "flex-start",
}))

export default CheckboxComponent
